import $ from 'jquery';

export default function accordion() {

  function init() {
    // clickOut
    $(document).on("click", function (event) {
      if (!$(event.target).closest(".intranet-sort").length) {
        $(".intranet-sort").removeClass("open");
        $(".intranet-sort .js-accordion__toggle").attr("aria-expanded", "false");
      }
    });
    $(document).on("click", function (event) {
      if (!$(event.target).closest(".intranet-pagination__menu").length) {
        $(".intranet-pagination__menu").removeClass("open");
        $(".intranet-pagination__btn.js-accordion__toggle").attr("aria-expanded", "false");
      }
    });

    $(document).on('click', '.js-accordion__toggle', function() {
      const $toggle = $(this);
      const $accordion = $toggle.parents('.js-accordion');
      const isOpen = $accordion.hasClass('open');

      if (!isOpen) {
        if (!$toggle.hasClass('faccette__header') && !$toggle.hasClass('box-faq__title') &&
          !$toggle.hasClass('intranet-pagination__btn') && !$toggle.hasClass('intranet-user__btn') &&
          !$toggle.hasClass('intranet-sort__btn') && !$toggle.hasClass('box-iscrizioni__title')) {
          $('.js-accordion').removeClass('open');
          // reset aria-expanded su tutti gli altri toggle
          $('.js-accordion__toggle').attr('aria-expanded', 'false');
        }
        $accordion.addClass('open');
        $toggle.attr('aria-expanded', 'true');
      } else {
        $accordion.removeClass('open');
        $toggle.attr('aria-expanded', 'false');
      }
  });
  }
  
  $( document ).ready(function() {
    if($('.js-accordion .js-accordion__toggle').length > 0) {
      init();
    
      if (process.env.LIFERAY_ENV) {  
        Liferay.on('SPAReady',function(){
          Liferay.SPA.app.on('endNavigate', function() {
            $(document).off('click', '.js-accordion__toggle');

            init();
          })
        })
      }

    }
  });  
}